import { render, staticRenderFns } from "./accountDataPermissionManageDetail.vue?vue&type=template&id=6ce25aa2&scoped=true"
import script from "./accountDataPermissionManageDetail.vue?vue&type=script&lang=js"
export * from "./accountDataPermissionManageDetail.vue?vue&type=script&lang=js"
import style0 from "./accountDataPermissionManageDetail.vue?vue&type=style&index=0&id=6ce25aa2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce25aa2",
  null
  
)

export default component.exports